var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"data-po-exclude":"true"}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }